/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_164_TitleInputs */

const en_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citrus Macaron`)
};

const ar_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون الحمضيات`)
};

const de_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zitrus-Macaron`)
};

const es_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron cítrico`)
};

const fr_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron aux agrumes`)
};

const it_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron agli agrumi`)
};

const ja_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シトラスマカロン`)
};

const ko_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시트러스 마카롱`)
};

const pt_br_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron Cítrico`)
};

const ru_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цитрусовый макарон`)
};

const th_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการองซิตรัส`)
};

const tr_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narenciyeli Makaron`)
};

const zh_cn_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柑橘马卡龙`)
};

const zh_tw_tree_type_164_title = /** @type {(inputs: Tree_Type_164_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柑橘馬卡龍`)
};

/**
* | output |
* | --- |
* | "Citrus Macaron" |
*
* @param {Tree_Type_164_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_164_title = /** @type {((inputs?: Tree_Type_164_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_164_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_164_title(inputs)
	if (locale === "ar") return ar_tree_type_164_title(inputs)
	if (locale === "de") return de_tree_type_164_title(inputs)
	if (locale === "es") return es_tree_type_164_title(inputs)
	if (locale === "fr") return fr_tree_type_164_title(inputs)
	if (locale === "it") return it_tree_type_164_title(inputs)
	if (locale === "ja") return ja_tree_type_164_title(inputs)
	if (locale === "ko") return ko_tree_type_164_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_164_title(inputs)
	if (locale === "ru") return ru_tree_type_164_title(inputs)
	if (locale === "th") return th_tree_type_164_title(inputs)
	if (locale === "tr") return tr_tree_type_164_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_164_title(inputs)
	return zh_tw_tree_type_164_title(inputs)
});